/* global customElements, HTMLElement */
import Swiper from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'

import { effectInit, effectTarget, effectVirtualTransitionEnd, getSlideTransformEl } from 'swiper/effect-utils'
import { Keyboard, Navigation } from 'swiper/modules'

function EffectArch ({ swiper, on }) {
  const setTranslate = () => {
    const { slides, wrapperEl, slidesSizesGrid } = swiper
    const params = swiper.params.archEffect

    const isCenteredSlides = swiper.params.centeredSlides
    // const rotateFix = getRotateFix(swiper)

    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0
      wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`
    }

    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i]
      const slideProgress = slideEl.progress
      const progress = slideEl.progress

      const offset = slideEl.swiperSlideOffset
      const translateOffset = swiper.params.cssMode ? -offset - swiper.translate : -offset
      const translate = swiper.isHorizontal()
        ? `${translateOffset}px, 0, 0`
        : `0, ${translateOffset}px, 0`

      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length

      const targetEl = effectTarget(params, slideEl)

      targetEl.style.setProperty('--translate-base', translate) // nullifies Swiper’s default wrapper translate
      targetEl.style.setProperty('--progress', progress < 0
        ? Math.abs(progress)
        : -Math.abs(progress)
      )
    }
  }

  const setTransition = (duration) => {
    const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl))

    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`
      el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl) => {
        shadowEl.style.transitionDuration = `${duration}ms`
      })
    })

    effectVirtualTransitionEnd({ swiper, duration, transformElements, allSlides: true })
  }

  effectInit({
    effect: 'arch',
    swiper,
    on,
    setTranslate,
    setTransition,
    // perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  })
}

class RecurringEventsSlider extends HTMLElement {
  connectedCallback () {
    this.$swiper = this.querySelector('.js-recurring-events-slider__swiper')

    if (this.slidesCount === 0) {
      console.log('nope')
      return
    }

    this.swiper = new Swiper(this.$swiper, {
      modules: [EffectArch, Keyboard, Navigation],
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      centeredSlides: true,
      slidesPerView: 'auto', // necessary for looped slider to work properly
      spaceBetween: 0,
      effect: 'arch',
      grabCursor: true,
      slideToClickedSlide: true,
      initialSlide: this.initialSlideIndex,
      navigation: {
        nextEl: '.js-recurring-events-slider__button--next',
        prevEl: '.js-recurring-events-slider__button--prev'
      },
      on: {
        slideChange: (swiper) => {
          const slide = swiper.slides[swiper.previousIndex]
          slide?.querySelector('tb-flipcard')?.toggle(false)
        },
        touchStart: () => {
          this.classList.add('is-dragging')
        },
        touchEnd: () => {
          this.classList.remove('is-dragging')
        }
      }
    })
  }

  get slidesCount () {
    return this.querySelectorAll('.js-recurring-events-slider__slide').length
  }

  get todayDay () {
    const day = new Date().getDay()
    return day === 0 ? 7 : day
  }

  get initialSlideIndex () {
    const slides = this.querySelectorAll('.js-recurring-events-slider__slide')

    for (let i = 0; i < slides.length; i += 1) {
      const flipcard = slides[i].querySelector('tb-flipcard')
      if (!flipcard) continue

      let days
      try {
        days = JSON.parse(flipcard.getAttribute('data-days') || '[]')
      } catch {
        continue
      }

      if (days.includes(this.todayDay)) {
        return i
      }
    }

    return 0
  }
}

customElements.define('tb-recurring-events-slider', RecurringEventsSlider)

// class RecurringEventsSlider extends HTMLElement {
//   connectedCallback () {
//     this.$$flipcards = this.querySelectorAll('tb-flipcard')
//     this.addEventListener('flipcard:beforetoggle', (e) => this.handleFlipcardToggle(e))
//   }

//   handleFlipcardToggle (e) {
//     this.$$flipcards.forEach(flipcard => {
//       if (flipcard !== e.target) {
//         flipcard.toggle(false)
//       }
//     })
//   }
// }

// customElements.define('tb-recurring-events-slider', RecurringEventsSlider)
